import { render, staticRenderFns } from "./TranslationFileView.vue?vue&type=template&id=7fd11cc4&scoped=true"
import script from "./TranslationFileView.vue?vue&type=script&lang=js"
export * from "./TranslationFileView.vue?vue&type=script&lang=js"
import style0 from "./TranslationFileView.vue?vue&type=style&index=0&id=7fd11cc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd11cc4",
  null
  
)

export default component.exports